import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { DropdownService } from '@core/services/dropdown.service';
import { ButtonDirective } from '@shared/directives/button.directive';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [CommonModule, OverlayModule,ButtonDirective],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit, OnDestroy {
  // visible = true;
  visible = false;
  @Input({ required: true }) id!: string;
  @Input() listContainerClasses = '';
  @Input() buttonTitle = '';
  @Input() listItemClasses = '';
  @Input() actionList: DropDownModel[] = [];
  private subscription!: Subscription;

  private dropdownService = inject(DropdownService);
  activeSubmenuIndex: number | null = null;

  ngOnInit(): void {
    this.subscription = this.dropdownService.dropdownState$.subscribe((id) => {
      if (id !== this.id) {
        this.visible = false;
        this.closeSubmenu();
      }
    });
  }

  toggle() {
    this.visible = !this.visible;
    if (this.visible) {
      this.dropdownService.openDropdown(this.id);
    } else {
      this.closeSubmenu();
    }
  }

  toggleSubmenu(index: number, event: Event) {
    event.stopPropagation();
    this.activeSubmenuIndex = this.activeSubmenuIndex === index ? null : index;
  }

  closeSubmenu() {
    this.activeSubmenuIndex = null;
  }

  onChildAction(action: (() => void) | undefined) {
    action?.();
    this.toggle();
    this.closeSubmenu();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

export interface DropDownModel {
  title: string;
  action?: () => void;
  show?: boolean;
  children?: DropDownModel[];
}
